import wait from './wait';

/**
 * Resolves given Promise after specified amount of time in ms
 * @param {Promise.<any>} promise
 * @param {Number} ms
 */
function resolveAfter(promise, ms) {
  return Promise.race([promise, wait(ms)]);
}

export default resolveAfter;
